export const aspectRatioToFraction = (aspect) => {
    if (typeof aspect === 'string' && aspect.indexOf(':') > 0) {
        const [a, b] = aspect.split(':');
        return b / a;
    }
    else if (typeof aspect === 'number') {
        return aspect;
    }
    throw new TypeError('Aspect ratio is not a Number or String with the format n:m');
};
//# sourceMappingURL=aspectRatioToFraction.js.map